// src/shared/json-table/store.ts
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { TableState } from "./types";

type TablesStore = {
  tables: Record<string, TableState>;
  initTable: (id: string, init: TableState) => void;
  updateTable: (id: string, updater: (draft: TableState) => void) => void;
  getTable: (id: string) => TableState | undefined;
};

const defaultState: TableState = {
  pageIndex: 0,
  pageSize: 20,
  sort: [],
  filters: [],
  q: "",
  columnVisibility: {},
};

export const useTablesStore = create<TablesStore>()(
  immer((set, get) => ({
    tables: {},
    initTable: (id, init) =>
      set((draft) => {
        draft.tables[id] ??= { ...defaultState, ...init };
      }),
    updateTable: (id, updater) =>
      set((draft) => {
        draft.tables[id] ??= { ...defaultState };
        updater(draft.tables[id]);
      }),
    getTable: (id) => get().tables[id],
  }))
);

export const getDefaultState = (init?: Partial<TableState>): TableState => ({
  ...defaultState,
  ...init,
});